// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Name
    name: 'g-login-login__mfa',
    // #endregion
    // #region Data
    data: () => ({
        codeConfirmed: null,
        remember: false,
        errorMessage: "",
        isLoading: false,
        isSending: false
    }),
    // #endregion
    // #region Watch
    watch: {
        code: function (val) {
            this.errorMessage = '';
        },
    },
    // #endregion
    // #region Computed
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        disableLogin() {
            return utils.isNullOrEmpty(this.codeConfirmed) || this.codeConfirmed?.length != 6;
        }
    },
    // #endregion
    methods: {
        async resendCode() {
            // #region Check
            if (this.isLoading) {
                return;
            }
            // #endregion
            // #region Vars
            this.isSending = true;
            // #endregion
            try {
                // #region Run
                await appHost.login.sendMfaCode();
                {
                    // #region local
                    this.isSending = false;
                    // #endregion
                }
                // #endregion
                // #region Message
                this.$appHost.notification.showToast(this.$t('account.Messages.CodeResent'), "success");
                // #endregion
            }
            catch (e) {
                // #region Error
                this.errorMessage = utils.getAxiosErrorMessage(e);
                // #endregion
                // #region local
                this.isSending = false;
                // #endregion                    
            }
        },
        async execute() {
            // #region Check
            if (utils.isEmpty(this.codeConfirmed) || this.codeConfirmed?.length != 6) {
                return;
            }
            if (this.isLoading) {
                return;
            }
            // #endregion
            // #region Vars
            this.isLoading = true;
            this.errorMessage = "";
            // #endregion
            try {
                // #region Run
                let tData = {
                    code: this.codeConfirmed,
                    remember: this.remember,
                    xrsfToken: this.$route.params.xrsfToken
                };
                let tResult = await appHost.login.loginByMfa(tData);
                {
                    // #region Data
                    if (!tResult.isSucceded) {
                        this.errorMessage = tResult.errorMessage;
                    }
                    else {
                        if (this.$route.query?.returnUrl || this.$route.query?.ReturnUrl) {
                            //Parse
                            let tUrl = decodeURIComponent((this.$route.query?.returnUrl ?? this.$route.query?.ReturnUrl));
                            //Special
                            window.location.href = tUrl;
                        }
                        else if (tResult.redirectUrl) {
                            this.$router.push(tResult.redirectUrl);
                        }
                        else if (this.$appHost.config.loggedInUrl) {
                            nextTick(() => {
                                this.$router.push(this.$appHost.config.loggedInUrl);
                            });
                        }
                        else {
                            this.$router.push("/");
                        }
                    }
                    // #endregion
                    // #region local
                    this.isLoading = false;
                    // #endregion
                }
                // #endregion
            }
            catch (e) {
                // #region Error
                this.errorMessage = utils.getAxiosErrorMessage(e);
                // #endregion
                // #region local
                this.isLoading = false;
                // #endregion                    
            }
        }
    }
});
// #endregion
